import { ReactNode } from "react";

/**
 * Client Routes
 */
export enum Routes {
  adminHomePage = "/admin/home",
  home = "/",
  groupStylingLessons = "/group-styling-lessons",
  login = "/auth/login",
  register = "/auth/register",
  forgotPassword = "/auth/forgot-password/:hash",
  stylingOnline = "/styling-online",
  stylingProduction = "/styling-production",
  shoopingEscort = "/shooping-escort",
  personalStylingToHome = "/personal-styling-home",
  intrestedManager = "/admin/intrested-manager",
  courseDashboard = "/admin/course-dashboard",
  adminCourseDetails = "/admin/course-dashboard/:id",
  courseLandingPage = "/course-landing-page/:id",
  userCourses = "/my-courses",
  courseView = "/my-courses/:courseId",
  courseViewWithSection = "/my-courses/:courseId/:sectionId",
  courseViewWithSectionAndVideo = "/my-courses/:courseId/:sectionId/:videoId",
  courseBuyPage = "/buy-page/course/:courseId",
  adminTextEditor = "/admin/text-editor",
  couponCodeManager = "/admin/coupon-manager",
  adminStoreManager = "/admin/store-manager",
  adminStoreManagerSpecificStore = "/admin/store-manager/:storeId",
  popupStore = "/popup-store",
  popupStoreItem = "/popup-store/:itemId",
  boughtCoursePage = "/has-bought-page/:itemType/:itemId",
  groupStyling = "/group-styling",
  groupStylingBuyPage = "/group-styling-buy-page/:groupId",
  cartStorePopupBuyPage = "/buy-page/popup-cart",
  profile = "/profile",
  workshopTicket = "/profile/workshop-ticket/:workshopOrderId",
  adminUsersManager = "/admin/user-manager",
  generalStylingMenu = "/general-styling-menu",
  adminBoughtItemsManager = "/admin/bought-items-manager/:storeId",
  adminOpenAssetManager = "/admin/admin-open-asset-manager",
  adminWorkshopManager = "/admin/workshop-manager",
  adminWorkshopManagerSpecificWorkshop = "/admin/workshop-manager/:workshopId",
  adminWorkshopManagerSpecificWorkshopTicketManager = "/admin/workshop-manager-ticket-manager/:workshopId",
  adminEmailSender = "/admin/email-sender",
  adminCustomLandingCreator = "/admin/custom-landing-creator",
  customLandingPage = "/custom-landing-page/:id",
  openWorkshop = "/open-workshop",
  workshopBuyPage = "/buy-page/workshop/:workshopId/:fields",
  workshopBuyPageWithoutFields = "/workshopBuyPage/:workshopId",
  qrScanner = "/qr-scanner",
  assetShow = "/asset-show/:fileName",
  notFound = "/404",
  all = "*"
}

export interface RouteMenu {
  text: string;
  href?: Routes;
}

export interface RouteInfo {
  text: string;
  href?: Routes | string;
  hideOnNavbar?: boolean;
  element?: ReactNode;
  adminOnly?: boolean;
  subNavbarAdmin?: boolean;
  subRoutes?: RouteInfo[];
}
export type EnumDictionary<T extends string | symbol | number, U> = {
  [K in T]: U;
};
